import { forwardRef } from 'react';

import useFeatureFlag from 'hb-react/shared/hooks/useFeatureFlag';

import EventCardV1 from './EventCard/v1';
import EventCardV2 from './EventCard/v2';
import type { EventCardLegacyProps } from './types';

const EventCard = forwardRef((props: EventCardLegacyProps, ref) => {
  const { flagEvEventsBoRevamp } = useFeatureFlag();

  if (flagEvEventsBoRevamp) {
    return <EventCardV2 event={props.event} onClick={props.onClick} />;
  }

  return <EventCardV1 {...props} ref={ref} />;
});

export default EventCard;
